export default __webpack_public_path__ + "static/media/Harness of Brutal Carnage.f05afb01.jpg";